module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("ToDo Apps"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("To Do")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "todo-devin"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "side-todo"
  }, [_c('ul', [_c('li', {
    staticClass: "clearfix"
  }, [_c('img', {
    attrs: {
      "src": "http://api.randomuser.me/portraits/men/22.jpg",
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Vincent Porter")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fa fa-circle online"
  }), _vm._v(" online ")])])]), _vm._v(" "), _c('li', {
    staticClass: "completed"
  }, [_vm._v("Complete task "), _c('b', [_vm._v(_vm._s(_vm.todos.filter(function (todo) {
    return todo.done === true
  }).length))])]), _vm._v(" "), _c('li', {
    staticClass: "pending"
  }, [_vm._v("Pending task "), _c('b', [_vm._v(_vm._s(_vm.todos.filter(function (todo) {
    return todo.done === false
  }).length))])])]), _vm._v(" "), _c('create-todo', {
    on: {
      "create-todo": _vm.createTodo
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('todo-list', {
    attrs: {
      "todos": _vm.todos
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f40d78a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ToDo.vue
// module id = 1350
// module chunks = 2